import {
  hideProjectSensitiveFields,
  projectHasSensitiveData,
} from '@cd3p/core/utils/sensitiveData';
import { State } from 'modules';
import { userType as userTypeSelector } from 'selectors/app';

import { createSelector } from 'third-party';

export const projectData = (state: State) => state.project.project;

export const project = createSelector(
  [projectData, userTypeSelector],
  (project, userType) => {
    return projectHasSensitiveData(project!, userType)
      ? hideProjectSensitiveFields(project!)
      : project;
  },
);
export const updateProjectPending = (state: State) =>
  state.project.updateProjectPending;
export const createProjectPending = (state: State) =>
  state.project.createProjectPending;
export const loadProjectPending = (state: State) =>
  state.project.loadProjectPending;
export const deleteProjectPending = (state: State) =>
  state.project.deleteProjectPending;
export const projectLoaded = (state: State) => state.project.projectLoaded;
export const updateProjectErrorType = (state: State) =>
  state.project.updateProjectError?.body?.Type;
export const updateProjectErrorMessage = (state: State) =>
  state.project.updateProjectError?.body?.Title;
export const addProjectSubscriptionsPending = (state: State) =>
  state.project.addProjectSubscriptionsPending;
